module.exports = __webpack_public_path__ + "static/explorers-circle-5ff56f5e178dd53436d80f6c2b4dc026.svg";